import React, { Fragment, useEffect, useState, useContext } from 'react';
import Footer from '../../component/Other/Footer';
import Navbar from '../../component/Other/Navbar';
import { getLegislation } from '../../core/services/legislation';
import Head from '../../component/Section/Head';
import { AppContext } from '../../core/Contexts/AppContext';

const Legislation = () => {
  const { setTitle, setHeaderType, setImage } = useContext(AppContext);

  const [files, setFiles] = useState([]);
  const [error, setError] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    setTitle('კანონმდებლობა');
    setImage('../../images/hero-images/pattern-bg-optimized.jpg');

    setHeaderType(1);
  }, []);
  useEffect(() => {
    const fetchFilesList = async () => {
      try {
        const result = await getLegislation();
        if (Array.isArray(result)) {
          setFiles(result);
        } else {
          setFiles([]);
        }
      } catch (error) {
        setError('Error fetching files list');
        console.error('Error fetching files list:', error);
      }
    };

    fetchFilesList();
  }, []);

  // Group files by category
  const groupedFiles = files.reduce((acc, file) => {
    const category = file.category || 'Uncategorized';
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(file);
    return acc;
  }, {});

  const handleAccordionClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <Fragment>
      <section>
        <div className='container'>
          <div className='mb-5'>
            <div className='col-md-12'>
              <h3 className='bold font__size--32 text__32-1024 text-uppercase mb-3'>
                კანონმდებლობა
              </h3>

              <div className='accordion' id='filesAccordion'>
                {Object.keys(groupedFiles).length > 0 ? (
                  Object.keys(groupedFiles).map((category, index) => (
                    <div key={index} className='accordion-item mb-3'>
                      <h4 className='accordion-header'>
                        <button
                          className={`accordion-button ${
                            activeIndex === index ? '' : 'collapsed'
                          }`}
                          type='button'
                          onClick={() => handleAccordionClick(index)}
                          aria-expanded={activeIndex === index}
                        >
                          <span>{category}</span>
                          <span
                            className={`arrow-icon ${
                              activeIndex === index ? 'rotate' : ''
                            }`}
                          >
                            ↓
                          </span>
                        </button>
                      </h4>
                      <div
                        id={`collapse${index}`}
                        className={`accordion-collapse collapse ${
                          activeIndex === index ? 'show' : ''
                        }`}
                      >
                        <div className='accordion-body'>
                          {groupedFiles[category].map((file, idx) => (
                            <a
                              key={idx}
                              href={`${BASE_URL}/uploads/files/${
                                file.file_id
                              }/${encodeURIComponent(file.file_name)}`}
                              target='_blank'
                              rel='noopener noreferrer'
                              className='wrapper__list-document d-inline-block color__gray-1 my-3'
                            >
                              <div className='d-flex j-content-sb align-items-center'>
                                <div className='ml-2 semi-bold font__size--14 text__14-1024 text-uppercase'>
                                  {file.description}
                                </div>
                                <img src='./../images/pdf (1) 1.png' alt='' />
                              </div>
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div>No files available</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Legislation;
